import React from 'react'
import PropTypes from 'prop-types'

import { Mail, PhoneCallback } from '@aok/icon-functional'
import { Link } from '@aok/ui-elements'

import defaultProps from '../../../utils/propTypes/defaultProps'

import SmallContentContainer from '../../_layouts/SmallContentContainer/SmallContentContainer'
import AllroundContainer from '../../_layouts/AllroundContainer'

const ContactPartial = ({ email, tel, className }) => {
  return (
    <div className={`contactPartial flex flex-col 1000:w-1/2 ${className}`}>
      {email && (
        <Link
          theme="secondary"
          iconPosition="left"
          href={`mailto:${email}`}
          icon={<Mail className="w-16 h-16 mr-8 fill-current text-6d767c" />}
          title={<span className="relative text-6d767c">{email}</span>}
        />
      )}

      {tel && (
        <Link
          theme="secondary"
          iconPosition="left"
          href={`tel:${tel}`}
          title={<span className="relative text-6d767c">{tel}</span>}
          icon={<PhoneCallback className="w-16 h-16 mr-8 fill-current text-6d767c" />}
          className="mt-12 600:mt-4"
        />
      )}
    </div>
  )
}

const T008 = ({ contact }) => {
  const { title, author, company } = contact

  return (
    <AllroundContainer dataTrackingName="T008" className="t008">
      <SmallContentContainer isArticleContainer className="flex flex-col">
        <p className="font-semibold text-16 leading-24 1000:text-17 1280:text-18">{title}</p>

        {author && (
          <div className="flex flex-col mt-24 600:mt-32 1000:flex-row">
            <div className="flex items-center mb-16 1000:mb-0 1000:mr-32 1000:w-1/2">
              {/* Author image */}
              {author.image && (
                <img
                  className="rounded-full w-80 h-80 mr-24"
                  src={author.image.variants[0].url}
                  alt={author.image.alt}
                />
              )}

              {/* Author name */}
              <span className="flex flex-col">
                <span className="text-16 leading-24 mb-4">{`${author.name}`}</span>
                <span className="text-14 leading-20 font-light text-828b91">{author.jobTitle}</span>
              </span>
            </div>

            <ContactPartial {...author} className="1000:mt-4 1280:mt-16" />
          </div>
        )}

        {company && (
          <div className="flex flex-col mt-32 600:mt-24 1000:mt-32 1000:flex-row">
            <div className="mb-16 1000:mb-0 1000:mr-32 1000:w-1/2">
              {/* Company contact */}
              <span className="flex flex-col">
                <span className="text-16 leading-24 mb-4">{`${company.name},`}</span>
                <span className="text-14 leading-20 text-828b91">{`${company.address.street} ${company.address.streetNumber}, ${company.address.zipCode} ${company.address.city}`}</span>
              </span>
            </div>

            <ContactPartial {...company} />
          </div>
        )}
      </SmallContentContainer>
    </AllroundContainer>
  )
}

T008.propTypes = {
  contact: PropTypes.shape({
    title: PropTypes.string,
    author: PropTypes.shape({
      name: PropTypes.string,
      jobTitle: PropTypes.string,
      email: PropTypes.string,
      tel: PropTypes.string,
      image: PropTypes.shape({
        variants: PropTypes.arrayOf(
          PropTypes.shape({
            url: PropTypes.string,
            breakpoint: PropTypes.number,
          })
        ),
        alt: PropTypes.string,
      }),
    }),
    company: PropTypes.shape({
      name: PropTypes.string,
      address: PropTypes.shape({
        street: PropTypes.string,
        streetNumber: PropTypes.string,
        zipCode: PropTypes.string,
        city: PropTypes.string,
      }),
      email: PropTypes.string,
      tel: PropTypes.string,
    }),
  }),
}

T008.defalutProps = {
  contact: {
    title: defaultProps.TITLE,
    author: {
      name: defaultProps.NAME,
      jobTitle: 'Job Title nicht gesetzt',
      email: 'E-Mail nicht gesetzt',
      tel: 'Telefonnummer nicht gesetzt',
    },
  },
}

export default T008
